import * as React from "react";
import { SiteContext } from "../../../site-context/site-context";
import { THead } from "../../ui-library/table/table";
import styles from "./coin-tickers-table.styles";

const CoinTickersTableHead: React.FC = () => {
  const { isMobile } = React.useContext(SiteContext);

  return (
    <THead>
      {!isMobile && <th css={styles.colAlignment[0]}>#</th>}
      <th css={styles.colAlignment[1]}>Name</th>
      <th css={styles.colAlignment[2]}>Pair</th>
      <th css={styles.colAlignment[3]}>Price</th>
      <th css={styles.colAlignment[4]}>24h Volume</th>
      <th css={styles.colAlignment[5]}>Volume %</th>
    </THead>
  );
};

export default CoinTickersTableHead;
